import { iconDuplicate } from '@cube3/ui/src/icons/GeneralSVG';
import {
  ButtonFactory,
  ButtonFactoryConfig
} from '../../../../CommandBar/useButtonConfig';

export const DuplicateContractButtonFactory = (
  onClick: () => void
): ButtonFactory => {
  const f = (config: ButtonFactoryConfig) => {
    const { canWriteContract } = config.privileges;

    const disabledReason = (() => {
      switch (true) {
        case !canWriteContract:
          return 'This account has no permission to duplicate contract';
        default:
          return undefined;
      }
    })();

    return {
      icon: iconDuplicate,
      title: 'Duplicate',
      visible: true,
      disabled: !canWriteContract,
      disabledReason: disabledReason,
      onClick: onClick
    };
  };

  return {
    factory: f
  };
};
